import { CreateFramebufferWithAttachment, CreateTextureRT } from "./resourcesUtils";
import { GScreenDesc } from "./screenDesc";

export const GRenderTargets: {
    SceneColorTexture: WebGLTexture | null;
    SceneColorFramebuffer: WebGLFramebuffer | null;
    SceneColorTextureCopy: WebGLTexture | null;
    SceneColorFramebufferCopy: WebGLFramebuffer | null;
    SmokeTexture: WebGLTexture | null;
    SmokeFramebuffer: WebGLFramebuffer | null;
    SpotlightTexture: WebGLTexture | null;
    SpotlightFramebuffer: WebGLFramebuffer | null;
    bUseHalfResRT: boolean;
    DepthBuffer: WebGLRenderbuffer | null;
} = {
    SceneColorTexture: null,
    SceneColorFramebuffer: null,
    SceneColorTextureCopy: null,
    SceneColorFramebufferCopy: null,
    SmokeTexture: null,
    SmokeFramebuffer: null,
    SpotlightTexture: null,
    SpotlightFramebuffer: null,
    bUseHalfResRT: false,
    DepthBuffer: null,
};

export function AllocateMainRenderTargets(gl: WebGL2RenderingContext) {
    const size = GScreenDesc.RenderTargetSize;
    GScreenDesc.HalfResRenderTargetSize = GRenderTargets.bUseHalfResRT
        ? { x: GScreenDesc.RenderTargetSize.x * 0.5, y: GScreenDesc.RenderTargetSize.y * 0.5 }
        : GScreenDesc.RenderTargetSize;
    const textureInternalFormat = gl.R11F_G11F_B10F;
    const textureFormat = gl.RGB;
    const textureType = gl.HALF_FLOAT;

    //
    GRenderTargets.SceneColorTexture = CreateTextureRT(
        gl,
        size,
        textureInternalFormat,
        textureFormat,
        textureType,
        false,
    );
    GRenderTargets.SceneColorFramebuffer = CreateFramebufferWithAttachment(gl, GRenderTargets.SceneColorTexture!);

    //Fire Plane Depth Buffer
    // Create a renderbuffer for depth
    GRenderTargets.DepthBuffer = gl.createRenderbuffer();
    gl.bindRenderbuffer(gl.RENDERBUFFER, GRenderTargets.DepthBuffer);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH24_STENCIL8, size.x, size.y);
    gl.framebufferRenderbuffer(
        gl.FRAMEBUFFER,
        gl.DEPTH_STENCIL_ATTACHMENT,
        gl.RENDERBUFFER,
        GRenderTargets.DepthBuffer,
    );

    {
        GRenderTargets.SceneColorTextureCopy = CreateTextureRT(
            gl,
            size,
            textureInternalFormat,
            textureFormat,
            textureType,
            false,
        );
        GRenderTargets.SceneColorFramebufferCopy = CreateFramebufferWithAttachment(
            gl,
            GRenderTargets.SceneColorTextureCopy!,
        );

        gl.framebufferRenderbuffer(
            gl.FRAMEBUFFER,
            gl.DEPTH_STENCIL_ATTACHMENT,
            gl.RENDERBUFFER,
            GRenderTargets.DepthBuffer,
        );
    }
    /* gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, size.x, size.y);
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, GRenderTargets.DepthBuffer); */

    //Smoke
    GRenderTargets.SmokeTexture = CreateTextureRT(
        gl,
        GScreenDesc.HalfResRenderTargetSize,
        gl.RGBA8,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
    );
    GRenderTargets.SmokeFramebuffer = CreateFramebufferWithAttachment(gl, GRenderTargets.SmokeTexture!);
    // Attach the renderbuffer to the framebuffer
    //if (GScreenDesc.HalfResRenderTargetSize.x == size.x && GScreenDesc.HalfResRenderTargetSize.y == size.y)
    {
        gl.framebufferRenderbuffer(
            gl.FRAMEBUFFER,
            gl.DEPTH_STENCIL_ATTACHMENT,
            gl.RENDERBUFFER,
            GRenderTargets.DepthBuffer,
        );
    }

    //Spotlight
    GRenderTargets.SpotlightTexture = CreateTextureRT(
        gl,
        GScreenDesc.RenderTargetSize,
        textureInternalFormat,
        textureFormat,
        gl.HALF_FLOAT,
    );
    GRenderTargets.SpotlightFramebuffer = CreateFramebufferWithAttachment(gl, GRenderTargets.SpotlightTexture!);
}
